module.exports = __webpack_public_path__ + "de77a722/img/arrow-share-icon.00a12c29.svg";